export default __webpack_public_path__ + "static/contact-us-bg-3bc0a61d2fe103bdb23cbf26a9975d6d.jpeg";